<template>
	<div class="main">
		<h1>{{ $t("WordscapesErrorPageH1") }}</h1>
		<p class="body">{{ $t("WordscapesErrorPageText") }}</p>
		<div class="word-btns">
			<router-link
				:to="$t(firstButtonData.to)"
				:title="$t(firstButtonData.title)"
				:aria-label="$t(firstButtonData.label)"
				:class="{ 'word-btn--larger': isDailyPuzzleRoute }"
				class="word-btn home-btn"
			>
				{{ $t(firstButtonData.text) }}
			</router-link>
			<router-link
				v-if="secondButtonData"
				:to="secondButtonData.url"
				:title="secondButtonData.titleAttribute"
				:aria-label="secondButtonData.ariaLabel"
				:class="{ 'word-btn--larger': isDailyPuzzleRoute }"
				class="word-btn label-btn"
				v-html="secondButtonData.text"
			/>
		</div>
		<img
			:src="
				`/static/images/img-404-en-${
					isSmallDevice ? 'mobile' : 'desktop'
				}@2x.jpg`
			"
			:width="isSmallDevice ? 280 : 360"
			:height="isSmallDevice ? 156 : 200"
			alt="404 Not Found"
			class="not_found"
		/>
	</div>
</template>

<script>
import { PAGES } from "@/common/consts";
import { currentDateAsObject, capitalizeFirstLetter } from "@/common/functions";
import { getGroupInfo, getPackInfo } from "@/common/services/search";

export default {
	name: "NotFoundContent",
	data() {
		return {
			secondButtonData: null,
		};
	},
	computed: {
		currentDate() {
			return currentDateAsObject();
		},
		isDailyPuzzleRoute() {
			return this.$route.name === PAGES.DAILY_PUZZLE_ANSWERS;
		},
		firstButtonData() {
			return this.isDailyPuzzleRoute
				? {
						to: "ErrorPageButtonUrlWordscapesDailyIndex",
						text: "ErrorPageButtonTextWordscapesDailyIndex",
						title:
							"ErrorPageButtonTitleAttributeWordscapesDailyIndex",
						label: "ErrorPageButtonAriaLabelWordscapesDailyIndex",
				  }
				: {
						to: "WordscapesErrorPageButtonUrlHome",
						text: "WordscapesErrorPageButtonTextHome",
						title: "WordscapesErrorPageButtonTitleAttributeHome",
						label: "WordscapesErrorPageButtonAriaLabelHome",
				  };
		},
	},
	async created() {
		this.secondButtonData = await this.getSecondButtonData();
	},
	methods: {
		getPackButtonData(packInfo) {
			const route = this.$router.resolve({
				name: PAGES.PACK,
				params: {
					group: packInfo.group,
					pack: packInfo.name,
				},
			});

			const text = `Go to Pack ${capitalizeFirstLetter(packInfo.name)}`;

			return {
				text,
				url: route.href,
				titleAttribute: text,
				ariaLabel: text,
			};
		},
		getGroupButtonData(groupInfo) {
			const route = this.$router.resolve({
				name: PAGES.GROUP,
				params: {
					group: groupInfo.name,
				},
			});

			const text = `Go to Group ${capitalizeFirstLetter(groupInfo.name)}`;

			return {
				text,
				url: route.href,
				titleAttribute: text,
				ariaLabel: text,
			};
		},
		async getSecondButtonData() {
			const defaults = {
				text: this.$t("WordscapesErrorPageButtonTextWordscapesLevel"),
				url: this.$t("WordscapesErrorPageButtonUrlWordscapesLevel"),
				ariaLabel: this.$t(
					"WordscapesErrorPageButtonAriaLabelWordscapesLevel"
				),
				titleAttribute: this.$t(
					"WordscapesErrorPageButtonTitleAttributeWordscapesLevel"
				),
			};

			switch (this.$route.name) {
				case PAGES.LEVEL:
					const packInfo = await getPackInfo(
						this.$route.params.group,
						this.$route.params.pack
					);
					if (
						typeof packInfo === "object" &&
						typeof packInfo.name === "string"
					) {
						return this.getPackButtonData(packInfo);
					}

					const groupInfo = await getGroupInfo(
						this.$route.params.group
					);

					if (
						typeof groupInfo === "object" &&
						typeof groupInfo.name === "string"
					) {
						return this.getGroupButtonData(groupInfo);
					}

					return defaults;
				case PAGES.PACK:
					const info = await getGroupInfo(this.$route.params.group);

					if (
						typeof info === "object" &&
						typeof info.name === "string"
					) {
						return this.getGroupButtonData(info);
					}

					return defaults;
				case PAGES.DAILY_PUZZLE_ANSWERS:
					return {
						text: this.$t(
							"ErrorPageButtonTextWordscapesDailyDetail"
						),
						url: this.$t(
							"ErrorPageButtonUrlWordscapesDailyDetail",
							{
								DailyDetailPage: `/daily-puzzle/${this.currentDate.month.toLowerCase()}-${
									this.currentDate.day
								}-${this.currentDate.year}-answers/`,
							}
						),
						titleAttribute: this.$t(
							"ErrorPageButtonTitleAttributeWordscapesDailyDetail"
						),
						ariaLabel: this.$t(
							"ErrorPageButtonAriaLabelWordscapesDailyDetail"
						),
					};
				default:
					return defaults;
			}
		},
	},
};
</script>

<style lang="scss" scoped src="./content.scss" />
